var render = function render(){var _vm=this,_c=_vm._self._c;return _c('session-table',{attrs:{"sessions":_vm.sessions,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }